import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { Drawer, DrawerContent, DrawerItem, DrawerItemProps, DrawerSelectEvent } from '@progress/kendo-react-layout';
import { gridIcon, globeIcon, gearIcon, logoutIcon, chevronDownIcon, chevronRightIcon, plusIcon, circleIcon, chartLineIcon, clipboardTextIcon, userIcon, gearsIcon, lockIcon, mapMarkerTargetIcon, dataIcon, clockIcon, subreportIcon, clipboardCodeIcon, clockArrowRotateIcon, groupIcon, chartScatterIcon, usersSolidIcon, fileReportIcon } from '@progress/kendo-svg-icons';

import { useEffect, useState } from 'react';

import { useMsal } from '@azure/msal-react';

import { useLocalization } from '@progress/kendo-react-intl';

import { Header } from './Header';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Footer } from './Footer';

import { zone } from '../assets/zone'
import { sinottico } from '../assets/sinottico'
import { alarm } from '../assets/alarm'
import { beacon } from '../assets/beacon'

import { SvgIcon } from '@progress/kendo-react-common';


const CustomItem = (props: DrawerItemProps) => {
  const { visible, ...others } = props;
  const arrowDir = props.dataExpanded ? chevronDownIcon : chevronRightIcon;
  return props.visible === false ? null : (
    <DrawerItem {...others}>
      <SvgIcon icon={props.svgIcon} />
      <span className={"k-item-text"}>{props.text}</span>
      {props.dataExpanded !== undefined && (
        <SvgIcon
          icon={arrowDir}
          style={{
            marginLeft: "auto",
          }}
        />
      )}
    </DrawerItem>
  );
};

export const DrawerContainer = (props: any) => {

  const navigate = useNavigate();
  const location = useLocation();

  const selectedLocation = location.pathname;

  const [drawerExpanded, setDrawerExpanded] = useState(true);

  const { instance } = useMsal();

  const [isSmallerScreen, setIsSmallerScreen] = useState(window.innerWidth < 768);

  const [visible, setVisible] = useState<boolean>(false);

  const localizationService = useLocalization();

  const userType = localStorage.getItem('userType')
  const userEmail = localStorage.getItem('email');
  const username = localStorage.getItem('username');  
  const storedAdmin = localStorage.getItem('admin');
  //const admin = storedAdmin ? JSON.parse(storedAdmin) : false;


  const listMenuItems: any =
    [
      { separator: true },
      {
        text: localizationService.toLanguageString('dashboard.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('dashboard.title', 'NOT FOUND'),
        selected: true,
        id: 1,
        route: '/home/dashboard',
        svgIcon: gridIcon
      },
      {
        text: localizationService.toLanguageString('synoptic_devices.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('synoptic_devices.title', 'NOT FOUND'),
        id: 2,
        route: '/home/synoptic',
        svgIcon: sinottico
      },
      {
        text: localizationService.toLanguageString('beacons.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('beacons.title', 'NOT FOUND'),
        id: 3,
        route: '/home/beacons',
        svgIcon: beacon
      },
      {
        text: localizationService.toLanguageString('map.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('map.title', 'NOT FOUND'),
        id: 4,
        route: '/home/map',
        svgIcon: globeIcon,
      },
      {
        text: localizationService.toLanguageString('zone.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('zone.title', 'NOT FOUND'),
        id: 5,
        route: '/home/areas',
        svgIcon: zone,
      },
      {
        text: localizationService.toLanguageString('alarms.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('alarms.title', 'NOT FOUND'),
        id: 6,
        route: '/home/alarms',
        svgIcon: alarm,
      },
      {
        text: localizationService.toLanguageString('configuration.analysis.analysis_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.analysis.analysis_title', 'NOT FOUND'),
        id: 30,
        dataExpanded: false,
        svgIcon: chartLineIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.analysis.heatmap.heatmap_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.analysis.heatmap.heatmap_title', 'NOT FOUND'),
        id: 31,
        parentId: 30,
        level: 2,
        route: '/home/configuration/analysis/heatmap',
        svgIcon: chartScatterIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.analysis.path_history.path_history_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.analysis.path_history.path_history_title', 'NOT FOUND'),
        id: 32,
        parentId: 30,
        level: 2,
        route: '/home/configuration/analysis/path_history',
        svgIcon: chartLineIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.analysis.report.report_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.analysis.report.report_title', 'NOT FOUND'),
        id: 34,
        parentId: 30,
        level: 2,
        route: '/home/configuration/analysis/report',
        svgIcon: fileReportIcon,
      },
      {
        text: localizationService.toLanguageString('settings.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('settings.title', 'NOT FOUND'),
        id: 7,
        route: '/home/settings',
        svgIcon: gearIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.title', 'NOT FOUND'),
        id: 9,
        dataExpanded: false,
        //route: '/home/configuration',
        svgIcon: gearsIcon,
      },
      //{
      //  text: localizationService.toLanguageString('configuration.maps_title', 'NOT FOUND'),
      //  id: 11,
      //  parentId: 9,
      //  route: '/home/configuration/maps',
      //  svgIcon: globeIcon,
      //},
      //{
      //  text: localizationService.toLanguageString('configuration.beacons_title', 'NOT FOUND'),
      //  id: 12,
      //  parentId: 9,
      //  route: '/home/configuration/beacons',
      //  svgIcon: beacon,
      //},
      {
        text: localizationService.toLanguageString('configuration.devices_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.devices_title', 'NOT FOUND'),
        id: 13,
        parentId: 9,
        dataExpanded: false,
        //route: '/home/configuration/devices',
        svgIcon: sinottico,
      },
      {
        text: localizationService.toLanguageString('configuration.devices.devices_enable', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.devices.devices_enable', 'NOT FOUND'),
        id: 17,
        parentId: 13,
        level: 2,
        route: '/home/configuration/devices/devices-enable',
        svgIcon: circleIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.devices.devices_management', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.devices.devices_management', 'NOT FOUND'),
        id: 18,
        parentId: 13,
        level: 2,
        route: '/home/configuration/devices/devices-management',
        svgIcon: circleIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.devices.devices_binding', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.devices.devices_binding', 'NOT FOUND'),
        id: 19,
        parentId: 13,
        level: 2,
        route: '/home/configuration/devices/devices-binding',
        svgIcon: circleIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.rules_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.rules_title', 'NOT FOUND'),
        id: 14,
        parentId: 9,
        dataExpanded: false,
        //route: '/home/configuration/rules',
        svgIcon: clipboardTextIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.rules.timeslot', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.rules.timeslot', 'NOT FOUND'),
        id: 23,
        parentId: 14,
        level: 2,
        route: '/home/configuration/rules/timeslot',
        svgIcon: clockIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.rules.subscription', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.rules.subscription', 'NOT FOUND'),
        id: 24,
        parentId: 14,
        level: 2,
        route: '/home/configuration/rules/subscription',
        svgIcon: subreportIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.rules.alarmActionHandlers', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.rules.alarmActionHandlers', 'NOT FOUND'),
        id: 25,
        parentId: 14,
        level: 2,
        route: '/home/configuration/rules/alarm-action-handlers',
        svgIcon: alarm,
      },
      {
        text: localizationService.toLanguageString('configuration.rules.subscriptionAPI', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.rules.subscriptionAPI', 'NOT FOUND'),
        id: 26,
        parentId: 14,
        level: 2,
        route: '/home/configuration/rules/subscription-api',
        svgIcon: clipboardCodeIcon,
      },      
      {
        text: localizationService.toLanguageString('configuration.locator_title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.locator_title', 'NOT FOUND'),
        id: 15,
        parentId: 9,
        dataExpanded: false,
        svgIcon: mapMarkerTargetIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.locator.server', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.locator.server', 'NOT FOUND'),
        id: 21,
        parentId: 15,
        level: 2,
        route: '/home/configuration/locator/server',
        svgIcon: dataIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.locator.collector', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.locator.collector', 'NOT FOUND'),
        id: 22,
        parentId: 15,
        level: 2,
        route: '/home/configuration/locator/collector',
        svgIcon: circleIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.registry.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.registry.title', 'NOT FOUND'),
        id: 27,
        parentId: 9,
        dataExpanded: false,
        svgIcon: userIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.registry.groups', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.registry.groups', 'NOT FOUND'),
        id: 28,
        parentId: 27,
        level: 2,
        route: '/home/configuration/registry/groups',
        svgIcon: groupIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.registry.jobs', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.registry.jobs', 'NOT FOUND'),
        id: 29,
        parentId: 27,
        level: 2,
        route: '/home/configuration/registry/jobs',
        svgIcon: circleIcon,
      },
      {
        text: localizationService.toLanguageString('configuration.registry.account.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('configuration.registry.account.title', 'NOT FOUND'),
        id: 33,
        parentId: 27,
        level: 2,
        route: '/home/configuration/registry/accounts',
        svgIcon: usersSolidIcon,
      },
      {
        text: localizationService.toLanguageString('map.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('map.title', 'NOT FOUND'),
        id: 40,
        parentId: 9,
        dataExpanded: false,
        svgIcon: globeIcon,
      },      
      {
        text: localizationService.toLanguageString('zone.title', 'NOT FOUND'),
        title: localizationService.toLanguageString('zone.title', 'NOT FOUND'),
        id: 41,
        parentId: 40,
        level: 2,
        route: '/home/configuration/maps/zones',
        svgIcon: zone,
      },
      //{
      //  text: localizationService.toLanguageString('configuration.privacy_title', 'NOT FOUND'),
      //  id: 16,
      //  parentId: 9,
      //  route: '/home/configuration/privacy',
      //  svgIcon: lockIcon,
      //},
      { separator: true },
      {
        text: localizationService.toLanguageString('logout', 'NOT FOUND'),
        title: localizationService.toLanguageString('logout', 'NOT FOUND'),
        id: 10,
        route: '/',
        svgIcon: logoutIcon,
      }
    ]


  const [items, setItems] = useState<any[]>(listMenuItems)

  useEffect(() => {
    setItems(listMenuItems)
  }, [localStorage.getItem('languageId')])


  const resizeWindow = () => {
    setIsSmallerScreen(window.innerWidth < 768);
  }

  const keysToKeep = [
    `tileState: ${userEmail}`,
    `languageId`
  ];

  const clearLocalStorageExcept = (keysToKeep: any) => {
    const localStorageKeys = Object.keys(localStorage);

    localStorageKeys.forEach(key => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  }

  // toggle popup when click on logout button
  const toggleDialog = () => {
    setVisible(!visible);

    const isSSO = localStorage.getItem('sso')
    clearLocalStorageExcept(keysToKeep)

    if (isSSO == 'true') {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      navigate('/');
    }
  };

  const isTokenExpired = () => {
    //const token:any = localStorage.getItem('accessToken') || localStorage.getItem('accessToken');
    const token: any = localStorage.getItem('accessToken');

    if (!token) {
      //localStorage.removeItem('accessToken');
      return true;  // If no token, consider it expired
    }

    try {
      const base64Url = token?.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/'); // Convert to base64 encoding
      const decodedPayload = JSON.parse(atob(base64)); // Decode base64 to JSON
      //const decodedToken:any = jwtDecode(decodedPayload);
      const currentTime = Date.now() / 1000; // Current time in seconds
      return decodedPayload.exp < currentTime;
    } catch (e) {
      return true; // If token is invalid, treat it as expired
    }
  };

  useEffect(() => {
    const isSSO = localStorage.getItem('sso')

    if (isSSO != 'true' && isTokenExpired()) {
      toggleDialog(); // If token is expired, log out
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', resizeWindow, false)
    resizeWindow();
  }, [])

  const handleClick = () => {
    setDrawerExpanded(!drawerExpanded);
    if (drawerExpanded) {

    }
  };

  const onSelect = (ev: DrawerSelectEvent) => {
    const currentItem = ev?.itemTarget?.props;
    const isParent = currentItem?.dataExpanded !== undefined;
    const nextExpanded = !currentItem?.dataExpanded;
    const newData = items.map((item: any) => {
      const { selected, dataExpanded: currentExpanded, id, ...others } = item;
      const isCurrentItem = currentItem?.id === id;
      return {
        selected: isCurrentItem,
        dataExpanded: isCurrentItem && isParent ? nextExpanded : currentExpanded,
        id,
        ...others,
      };
    });
    if (ev?.itemTarget?.props?.text == localizationService.toLanguageString('logout', 'NOT FOUND')) {
      //toggleDialog()
      setVisible(true)
    } else {
      navigate(ev?.itemTarget?.props?.route);
    }
    setItems(newData);
  };

  const data = items.map((item: any) => {
    const { parentId, ...others } = item;

    if (item.id == 9) {
      items.forEach((nestedItem: any) => {
        if (nestedItem.id != 9) {
          if (nestedItem.dataExpanded) {
            if (item.id == 9 && item.selected) {
              nestedItem.dataExpanded = false
            }
          }
        }
      })
    }

    let hiddenIds:any = [];

    // 2: Synoptic, 3: Beacons, 8: Synchro, 15: Locator settings, 17: Device enable, 
    // 18: Device management, 19: Device binding, 20: Synchro settings, 
    // 23: Timeslot, 24: Subscription, 25: Alarm action handler, 26: SubscriptionAPI, 27: Registry
    // 32: Path history, 33: Accounts, 40: Map configuration, 41: Zone configuration

    switch (userType) {
      //case 'UbiquicomAdminOnlyLocator':
      //  if (item.id == 8 || item.id == 20) {
      //    return {
      //      visible: false
      //    }
      //  }
      //  break;
      //case 'UserAdmin':
      //  hiddenIds = [15, 20];
      //  if (hiddenIds.includes(item.id)) {
      //    return { visible: false };
      //  }
      //  break;
      case 'UserAdminOnlyLocator':
        hiddenIds = [8, 15, 20];
        if (hiddenIds.includes(item.id)) {
          return { visible: false };
        }
        break;
      case 'StandardOnlyLocator':
        hiddenIds = [8, 15, 17, 18, 20, 26, 33];
        if (hiddenIds.includes(item.id)) {
          return { visible: false };
        }
        break;
      //case 'StandardOnlySyncro':
      //  if (item.id != 2 && item.id != 3 && item.id != 8 && item.id != 10) {
      //    return {
      //      visible: false
      //    }
      //  }
      //  break;
      //case 'Standard':
      //  hiddenIds = [15, 17, 20, 26, 33];
      //  if (hiddenIds.includes(item.id)) {
      //    return { visible: false };
      //  }
      //  break;
      default:
        break;
    }


    if (parentId !== undefined) {
      const parentEl: any = items.find((parent: any) => parent.id === parentId);
      return {
        ...others,
        className: `${item.level != 2 ? 'k-level-1' : 'k-level-2'}`,
        visible: parentEl && parentEl.dataExpanded,
        selected: item.route === selectedLocation
      };
    }
    //else if (username == 'azure') {
    //  if (item.id != 10 && item.id != 32) {
    //    return {
    //      visible: false
    //    }
    //  }
    //  return {
    //    ...others,
    //    selected: item.route === selectedLocation
    //  };
    //}
    else {
      return {
        ...others,
        //selected: item.text === selected 
        selected: item.route === selectedLocation
      };
    }
  });

  return (
    <>

      <Header onButtonClick={handleClick} changeTheme={props.changeTheme} theme={props.theme} />

      <div>

        {visible && (
          <Dialog
            title={localizationService.toLanguageString('are_you_sure_to_exit', 'NOT FOUND')}
            onClose={toggleDialog}
          >
            <div>
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base logout"
                onClick={() => setVisible(false)}
              >
                {localizationService.toLanguageString('no', 'NOT FOUND')}
              </button>
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base logout"
                onClick={() => {
                  if (visible) {
                    toggleDialog()
                  }
                }}
              >
                {localizationService.toLanguageString('yes', 'NOT FOUND')}
              </button>
            </div>
          </Dialog>
        )}


        <Drawer
          expanded={drawerExpanded}
          //position={'start'}
          mode={isSmallerScreen ? 'overlay' : 'push'}
          mini={isSmallerScreen ? false : true}
          width={320}
          items={data}
          item={CustomItem}
          onSelect={onSelect}
          className={!drawerExpanded ? 'k-drawer-item expanded' : ''}
        >
          <DrawerContent
            style={{
              position: "relative",
              //background: '#F7F7F7',
              //overflow: `${selectedLocation.includes('map') ? 'hidden' : 'auto'}` 
            }}
          >
            {props.children}
            <Outlet />
          </DrawerContent>
        </Drawer>
      </div>
      <Footer />
    </>
  );
};